const { upgradeArray } = require('../utils')

const PAYMENTS_LOG_DIRECTION = upgradeArray([ 'incoming', 'outgoing' ])

module.exports = { PAYMENTS_LOG_DIRECTION }
